import React from 'react';
import TopicLayout from '../Js_files/Topic_layout';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll';


const File6 = () => {
   const [showScrollTop, setShowScrollTop] = useState(false);
    const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
             useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  const topics = [
    {
      title: "Visual Arts",
      description: "Traditional and digital art techniques, drawing, painting, and visual composition principles.",
      tags: ["Drawing", "Painting", "Digital Art", "Composition", "Color Theory"]
    },
    {
      title: "Graphic Design",
      description: "Brand identity, typography, layout design, and visual communication for print and digital media.",
      tags: ["Typography", "Branding", "Layout", "Adobe Creative Suite", "Logo Design"]
    },
    {
      title: "UI/UX Design",
      description: "User interface and user experience design for websites, mobile apps, and digital products.",
      tags: ["User Research", "Wireframing", "Prototyping", "Usability", "Design Systems"]
    },
    {
      title: "Photography",
      description: "Digital photography techniques, composition, lighting, and photo editing for various applications.",
      tags: ["Composition", "Lighting", "Photo Editing", "Portrait", "Landscape"]
    },
    {
      title: "Art History",
      description: "Study of art movements, famous artists, and the cultural context of artistic expression throughout history.",
      tags: ["Art Movements", "Famous Artists", "Cultural Context", "Analysis"]
    },
    {
      title: "Creative Writing",
      description: "Fiction, poetry, screenwriting, and various forms of creative expression through written word.",
      tags: ["Fiction", "Poetry", "Screenwriting", "Storytelling", "Character Development"]
    }
  ];

  const resources = [
    {
      icon: "🎨",
      title: "Design Software",
      description: "Adobe Creative Suite, Figma, Sketch, and other professional design and art creation tools."
    },
    {
      icon: "📸",
      title: "Equipment & Tools",
      description: "Cameras, drawing tablets, art supplies, and professional equipment for various art forms."
    },
    {
      icon: "🖼️",
      title: "Galleries & Museums",
      description: "Virtual museum tours, art galleries, and exhibitions for inspiration and learning."
    },
    {
      icon: "👥",
      title: "Communities",
      description: "Artist communities, critique groups, and collaborative platforms for feedback and growth."
    }
  ];

  const careerPaths = [
    {
      title: "Graphic Designer",
      description: "Create visual content for brands, marketing materials, and digital media across various industries.",
      skills: ["Adobe Creative Suite", "Typography", "Branding", "Layout Design"]
    },
    {
      title: "UI/UX Designer",
      description: "Design user interfaces and experiences for websites, mobile apps, and digital products.",
      skills: ["User Research", "Prototyping", "Design Systems", "Usability Testing"]
    },
    {
      title: "Art Director",
      description: "Lead creative teams and oversee visual concepts for advertising, media, and marketing campaigns.",
      skills: ["Creative Leadership", "Concept Development", "Team Management", "Brand Strategy"]
    },
    {
      title: "Freelance Artist",
      description: "Work independently on various art projects, commissions, and creative endeavors.",
      skills: ["Portfolio Development", "Client Management", "Marketing", "Diverse Art Skills"]
    }
  ];

  return (
    <>
      <Navbar onEnrollClick={() => setShowForm(true)}/>
    <TopicLayout
      title="Arts & Design"
      icon="🎨"
      color="#DDA0DD"
      description="Explore creative design principles, visual arts, and artistic techniques. Learn about color theory, composition, and the intersection of technology with traditional and digital art forms."
      topics={topics}
      resources={resources}
      careerPaths={careerPaths}
    />
    <Footer/>

     <a
        href="https://wa.me/9042857947"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default File6;